/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { DHSurveyJobDefinition } from '../models/DHSurveyJobDefinition';
import type { GetDuplicateJobsResponse } from '../models/GetDuplicateJobsResponse';
import type { GetParticipationSurveyJobCompanyJobsRequest } from '../models/GetParticipationSurveyJobCompanyJobsRequest';
import type { GetParticipationSurveyJobCompanyJobsResponse } from '../models/GetParticipationSurveyJobCompanyJobsResponse';
import type { Participation } from '../models/Participation';
import type { ParticipationJobMappingsRequest } from '../models/ParticipationJobMappingsRequest';
import type { ParticipationTab } from '../models/ParticipationTab';
import type { ParticipationUserCustomFieldFilter } from '../models/ParticipationUserCustomFieldFilter';
import type { SalaryRangeTypeOfPay } from '../models/SalaryRangeTypeOfPay';
import type { SaveParticipationSurveyJobCompanyJobMappingsRequest } from '../models/SaveParticipationSurveyJobCompanyJobMappingsRequest';
import type { SaveParticipationSurveyJobCompanyJobMappingsResponse } from '../models/SaveParticipationSurveyJobCompanyJobMappingsResponse';
import type { SurveyJobCompanyJobMapping } from '../models/SurveyJobCompanyJobMapping';
import type { SurveyJobCompanyJobMappingDuplicate } from '../models/SurveyJobCompanyJobMappingDuplicate';
import type { SurveyJobCompanyJobMappingStatus } from '../models/SurveyJobCompanyJobMappingStatus';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class ParticipationService {

    /**
     * List Participation Templates
     * @returns any Success
     * @throws ApiError
     */
    public static listParticipationTemplates({
        vendor,
        profile,
        search,
        offset,
        limit,
        order,
    }: {
        vendor?: string,
        profile?: string,
        search?: string,
        offset?: number,
        limit?: number,
        order?: Record<string, any>,
    }): CancelablePromise<{
        rows: Array<Participation>;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/participation',
            query: {
                'vendor': vendor,
                'profile': profile,
                'search': search,
                'offset': offset,
                'limit': limit,
                'order': order,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Sync Participation Templates (add, remove, update plans in a single transaction)
     * @returns any Success
     * @throws ApiError
     */
    public static syncParticipations({
        requestBody,
    }: {
        requestBody?: {
            additions?: Array<{
                participationId: string;
                planIds?: Array<number>;
            }>;
            removals?: Array<string>;
            planUpdates?: Array<{
                participationId: string;
                planIds: Array<number>;
            }>;
        },
    }): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/participation/sync',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Get Participation Template
     * @returns Participation Success
     * @throws ApiError
     */
    public static getParticipationTemplate({
        participationId,
    }: {
        participationId: string,
    }): CancelablePromise<Participation> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/participation/{participationId}',
            path: {
                'participationId': participationId,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Get Participation Field Mappings
     * @returns any Success - Returns all compensation tabs with merged field mappings
     * @throws ApiError
     */
    public static getParticipationFieldMappings({
        participationId,
    }: {
        participationId: string,
    }): CancelablePromise<{
        tabs?: Array<ParticipationTab>;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/participation/{participationId}/fieldMappings',
            path: {
                'participationId': participationId,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Update Participation
     * @returns any Success
     * @throws ApiError
     */
    public static updateParticipation({
        participationId,
        requestBody,
    }: {
        participationId: string,
        requestBody: {
            tabs: Array<ParticipationTab>;
        },
    }): CancelablePromise<{
        success?: boolean;
    }> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/participation/{participationId}/fieldMappings',
            path: {
                'participationId': participationId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Delete Participation Field Mappings
     * @returns void
     * @throws ApiError
     */
    public static deleteCustomParticipationFieldMappings({
        participationId,
    }: {
        participationId: string,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/participation/{participationId}/fieldMappings',
            path: {
                'participationId': participationId,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Get Participation Template Data
     * @returns any Success
     * @throws ApiError
     */
    public static getParticipationData({
        participationId,
        requestBody,
    }: {
        participationId: string,
        requestBody: {
            plan: number;
            mappingType: Array<SurveyJobCompanyJobMappingStatus>;
            tabName: string;
            module?: Array<string>;
            country?: Array<string>;
            state?: Array<string>;
            /**
             * Filter by custom field values. The reserved value "__blank__" matches employees where customField is NULL.
             */
            customField?: Array<string>;
            /**
             * Filters by customer-created participation fields. Each entry references a field by its label and applies EQUAL / NOT EQUAL against the value. When a label is mapped to multiple `mappedField` paths across tabs, EQUAL matches if any mappedField equals the value and NOT EQUAL requires all mappedFields to differ. An empty array is valid and applies no filter.
             *
             */
            userCustomFields?: Array<ParticipationUserCustomFieldFilter>;
            typeOfPay?: SalaryRangeTypeOfPay;
            sort?: Record<string, any>;
            limit?: number;
            offset?: number;
            includeSlottedMappings?: boolean;
        },
    }): CancelablePromise<{
        rows?: any[];
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/participation/{participationId}/data',
            path: {
                'participationId': participationId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Export Participation Template Data
     * @returns any Success
     * @throws ApiError
     */
    public static exportParticipationData({
        participationId,
        requestBody,
    }: {
        participationId: string,
        requestBody?: {
            plan: number;
            mappingType: Array<string>;
            module?: Array<string>;
            typeOfPay?: SalaryRangeTypeOfPay;
            includeSlottedMappings?: boolean;
            /**
             * Customer-created custom field filters applied to the exported employee rows. Same shape as the `/data` endpoint. When a fieldName's mappedFields span both SurveyJob.* and other paths, the predicates compose with AND across kinds (rows must match in both the SQL filter and the SurveyJob pre-filter to appear).
             *
             */
            userCustomFields?: Array<ParticipationUserCustomFieldFilter>;
        },
    }): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/participation/{participationId}/export',
            path: {
                'participationId': participationId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Get Participation Job Mappings
     * @returns any Success
     * @throws ApiError
     */
    public static getParticipationJobMappings({
        participationId,
        requestBody,
    }: {
        participationId: string,
        requestBody: ParticipationJobMappingsRequest,
    }): CancelablePromise<{
        SurveyJobs?: Array<DHSurveyJobDefinition>;
        SurveyJobCompanyJobMappings?: Array<SurveyJobCompanyJobMapping>;
        SurveyJobCompanyJobMappingsDuplicates?: Array<SurveyJobCompanyJobMappingDuplicate>;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/participation/{participationId}/jobMappings',
            path: {
                'participationId': participationId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Get Company Jobs for Survey Job Mapping
     * @returns GetParticipationSurveyJobCompanyJobsResponse Success
     * @throws ApiError
     */
    public static getParticipationSurveyJobCompanyJobs({
        participationId,
        requestBody,
    }: {
        participationId: string,
        requestBody: GetParticipationSurveyJobCompanyJobsRequest,
    }): CancelablePromise<GetParticipationSurveyJobCompanyJobsResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/participation/{participationId}/jobMappings/search/companyJobs',
            path: {
                'participationId': participationId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Save Survey Job to Company Job Mappings
     * @returns SaveParticipationSurveyJobCompanyJobMappingsResponse Success
     * @throws ApiError
     */
    public static saveParticipationSurveyJobCompanyJobMappings({
        participationId,
        requestBody,
    }: {
        participationId: string,
        requestBody: SaveParticipationSurveyJobCompanyJobMappingsRequest,
    }): CancelablePromise<SaveParticipationSurveyJobCompanyJobMappingsResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/participation/{participationId}/jobMappings/surveyJob',
            path: {
                'participationId': participationId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Get Participation Job Mappings Count
     * @returns any Success
     * @throws ApiError
     */
    public static getParticipationJobMappingsCount({
        participationId,
        requestBody,
    }: {
        participationId: string,
        requestBody?: Record<string, any>,
    }): CancelablePromise<{
        MappedJobsCount?: number;
        TotalJobsCount?: number;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/participation/{participationId}/jobMappingsCount',
            path: {
                'participationId': participationId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Get Duplicate Job Mappings for a Company Job
     * @returns GetDuplicateJobsResponse Success
     * @throws ApiError
     */
    public static getDuplicateJobs({
        participationId,
        companyJobId,
        requestBody,
    }: {
        participationId: string,
        companyJobId: number,
        requestBody?: {
            /**
             * Plan ID (defaults to current plan)
             */
            planId?: number;
        },
    }): CancelablePromise<GetDuplicateJobsResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/participation/{participationId}/duplicateJobs/{companyJobId}',
            path: {
                'participationId': participationId,
                'companyJobId': companyJobId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * List Custom Filter Options
     * Returns the unique, alphabetically-sorted list of customer-created custom field labels from the participation's compensation tabs. When the participation has multiple tabs, the labels from all tabs are merged into a single list.
     *
     * @returns any Success
     * @throws ApiError
     */
    public static listCustomFilterOptions({
        participationId,
    }: {
        participationId: string,
    }): CancelablePromise<{
        customFields: Array<string>;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/participation/{participationId}/customFilterOptions',
            path: {
                'participationId': participationId,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * List Custom Filter Values
     * Returns the unique, alphabetically-sorted list of employee values for a single customer-created custom field on a participation. The same field label can be mapped to different EmployeeData paths across tabs (e.g. `region` in one tab, `EmployeeUDF.text5` in another) — values from every mapping are merged into one list. Employee data is paged through in batches to keep memory bounded.
     *
     * @returns any Success
     * @throws ApiError
     */
    public static listCustomFilterValues({
        participationId,
        planId,
        fieldName,
    }: {
        participationId: string,
        /**
         * Plan whose employee data file the values are drawn from.
         */
        planId: number,
        /**
         * Label of the customer-created custom field.
         */
        fieldName: string,
    }): CancelablePromise<{
        values: Array<string>;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/participation/{participationId}/customFilterValues',
            path: {
                'participationId': participationId,
            },
            query: {
                'planId': planId,
                'fieldName': fieldName,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

}
